import { Injectable } from '@angular/core';
import { EnumApiScales, EnumMeasureTypes } from '@library/store/measures/measures.interface';
import { GraphTooltipService } from '@molecules/graph-tooltip/graph-tooltip.service';
import { YScaleType } from '@pages/control-page/control-page-main/control-page-compare/cp-compare-sidebar/cp-compare-sidebar.service';
import { GraphDataset } from '@pages/control-page/control-page-store.service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class CpForecastRainTooltipService extends GraphTooltipService {

  apiScale$ = new BehaviorSubject(EnumApiScales.THREE_HOURS);
  measureCards$ = new BehaviorSubject([
    RainGraphDataset,
    RainProbaGraphDataset,
  ]);

  constructor() {
    super();
    this.createTooltip('cursor');
  }
}

export const RainGraphDataset: GraphDataset = {
  hidden: false,
  measureType: EnumMeasureTypes.SUM_RAIN,
  label: 'common-app.__RAIN',
  yScaleType: YScaleType.RAIN,
  type: 'bar',
  color: '--blue-10',
};

export const RainProbaGraphDataset: GraphDataset = {
  hidden: false,
  measureType: EnumMeasureTypes.PROB_RAIN,
  label: 'station-app.__WIDGET_RAIN_PROBABILITY',
  yScaleType: YScaleType.PERCENTAGE,
  type: 'line',
  color: '--blue',
};